
 import { Injectable } from '@angular/core';
 
 @Injectable({
   providedIn: 'root',
 })

 export class UtilsService { 

    constructor() {}

    public toggleHorarios(index?: number) {
        const element = document.getElementById(`schedule-${index}`);
        const verBtn = document.getElementById(`ver-${index}`);
        const fecharBtn = document.getElementById(`fechar-${index}`);

        if (element) {
            const hasDisplayNone = (element && element.offsetHeight === 0 && element.offsetWidth === 0);
            if(hasDisplayNone) {
                element.style.display = 'flex';
                if (verBtn) verBtn.style.display = 'none';
                if (fecharBtn) fecharBtn.style.display = 'block';
            } else {
                element.style.display = 'none';
                if (verBtn) verBtn.style.display = 'block';
                if (fecharBtn) fecharBtn.style.display = 'none';
            }
        }
    }

    
    public getLimitDays() {
        let limit = 3;
        const windowSize = window.innerWidth || 0;
        if (windowSize <= 768) {
        limit = 2;
        } 
        return limit;
    }
}